import * as fromDatatype from '../datatype-library/index';

export interface Treatment {
  treatment_type: string;
  price_source?: string;
  operator?: string;
  treatment_value?: number;
  min_value?: number;
  max_value?: number;
  validity_days?: number;
  point_ccy_code?: string;
  treatment_sub_type?: string;
  item_name?: string;
  item_code?: string;
  item_guid?: string;
  auto_apply_to_all_child_items?: boolean;
  lines?: string[];
}

export interface CouponTreatmentJsonDatatypeInterface extends fromDatatype.JsonDatatypeInterface {
  treatment?: Treatment[]
}

export interface CouponGenerateConfig {
  chars: string;
  length: number;
}

export interface bl_fi_mst_coupon_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  serial_number: fromDatatype.VarcharDatatypeInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  conditional_filter_json: fromDatatype.JsonDatatypeInterface;
  coupon_type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  usage_json: fromDatatype.JsonDatatypeInterface;
  pricing_bundle_json: fromDatatype.JsonDatatypeInterface;
  payment_logic_json: fromDatatype.JsonDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  treatment_json: CouponTreatmentJsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  face_value: fromDatatype.NumericDatatypeInterface;
  softpin_config: boolean;
  softpin_length: fromDatatype.IntegerDatatypeInterface;
  url_key_config: boolean;
  url_key_length: fromDatatype.IntegerDatatypeInterface;
  prefix_config: boolean;
  prefix_code: fromDatatype.VarcharDatatypeInterface;
  prefix_length: fromDatatype.IntegerDatatypeInterface;
  activation_pin_config: boolean;
  activation_pin_length: fromDatatype.IntegerDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  url_forward: fromDatatype.VarcharDatatypeInterface;
  point_ccy_code: fromDatatype.VarcharDatatypeInterface;
  softpin_regex: fromDatatype.VarcharDatatypeInterface;
  serial_regex: fromDatatype.VarcharDatatypeInterface;
  softpin_generate_option: { generate: CouponGenerateConfig[] };
  serial_generate_option: { generate: CouponGenerateConfig[] };
  generated_count: fromDatatype.NumericDatatypeInterface;
  assigned_count: fromDatatype.NumericDatatypeInterface;
  redeemed_count: fromDatatype.NumericDatatypeInterface;
  quantity_type: fromDatatype.VarcharDatatypeInterface;
  allow_anonymous: boolean;
  assignment_status: fromDatatype.VarcharDatatypeInterface;
  cancellation_status: fromDatatype.VarcharDatatypeInterface;
  char_length: fromDatatype.IntegerDatatypeInterface;
  config_prefix: fromDatatype.VarcharDatatypeInterface;
  config_softpin_generation: fromDatatype.VarcharDatatypeInterface;
  config_urlkey: fromDatatype.VarcharDatatypeInterface;
  currency: fromDatatype.VarcharDatatypeInterface;
  face_value_amount: fromDatatype.NumericDatatypeInterface;
  fi_item_guid: fromDatatype.GuidDataFieldInterface;
  item_prefix: fromDatatype.VarcharDatatypeInterface;
  quantity_limit: fromDatatype.NumericDatatypeInterface;
  quantity_logic: fromDatatype.VarcharDatatypeInterface;
  redeemable_date_from: fromDatatype.TimestampTzDatatypeInterface;
  redeemable_date_to: fromDatatype.TimestampTzDatatypeInterface;
  redemption_status: fromDatatype.VarcharDatatypeInterface;
  sn_prefix: fromDatatype.VarcharDatatypeInterface;
  sn_prefix_choice: fromDatatype.VarcharDatatypeInterface;
  treatment_discount_type: fromDatatype.VarcharDatatypeInterface;
  urlkey_length: fromDatatype.IntegerDatatypeInterface;
  validity_status: fromDatatype.VarcharDatatypeInterface;
  terms_and_condition: fromDatatype.TextDatatypeInterface;
  is_shipping_voucher: boolean;
}

export class bl_fi_mst_coupon_hdr_RowClass
  implements bl_fi_mst_coupon_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  serial_number: fromDatatype.VarcharDatatypeInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  conditional_filter_json: fromDatatype.JsonDatatypeInterface;
  coupon_type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  usage_json: fromDatatype.JsonDatatypeInterface;
  pricing_bundle_json: fromDatatype.JsonDatatypeInterface;
  payment_logic_json: fromDatatype.JsonDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  treatment_json: CouponTreatmentJsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  face_value: fromDatatype.NumericDatatypeInterface;
  softpin_config: boolean;
  softpin_length: fromDatatype.IntegerDatatypeInterface;
  url_key_config: boolean;
  url_key_length: fromDatatype.IntegerDatatypeInterface;
  prefix_config: boolean;
  prefix_code: fromDatatype.VarcharDatatypeInterface;
  prefix_length: fromDatatype.IntegerDatatypeInterface;
  activation_pin_config: boolean;
  activation_pin_length: fromDatatype.IntegerDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  url_forward: fromDatatype.VarcharDatatypeInterface;
  point_ccy_code: fromDatatype.VarcharDatatypeInterface;
  softpin_regex: fromDatatype.VarcharDatatypeInterface;
  serial_regex: fromDatatype.VarcharDatatypeInterface;
  softpin_generate_option: { generate: CouponGenerateConfig[] };
  serial_generate_option: { generate: CouponGenerateConfig[] };
  generated_count: fromDatatype.NumericDatatypeInterface;
  assigned_count: fromDatatype.NumericDatatypeInterface;
  redeemed_count: fromDatatype.NumericDatatypeInterface;
  quantity_type: fromDatatype.VarcharDatatypeInterface;
  allow_anonymous: boolean;
  assignment_status: fromDatatype.VarcharDatatypeInterface;
  cancellation_status: fromDatatype.VarcharDatatypeInterface;
  char_length: fromDatatype.IntegerDatatypeInterface;
  config_prefix: fromDatatype.VarcharDatatypeInterface;
  config_softpin_generation: fromDatatype.VarcharDatatypeInterface;
  config_urlkey: fromDatatype.VarcharDatatypeInterface;
  currency: fromDatatype.VarcharDatatypeInterface;
  face_value_amount: fromDatatype.NumericDatatypeInterface;
  fi_item_guid: fromDatatype.GuidDataFieldInterface;
  item_prefix: fromDatatype.VarcharDatatypeInterface;
  quantity_limit: fromDatatype.NumericDatatypeInterface;
  quantity_logic: fromDatatype.VarcharDatatypeInterface;
  redeemable_date_from: fromDatatype.TimestampTzDatatypeInterface;
  redeemable_date_to: fromDatatype.TimestampTzDatatypeInterface;
  redemption_status: fromDatatype.VarcharDatatypeInterface;
  sn_prefix: fromDatatype.VarcharDatatypeInterface;
  sn_prefix_choice: fromDatatype.VarcharDatatypeInterface;
  treatment_discount_type: fromDatatype.VarcharDatatypeInterface;
  urlkey_length: fromDatatype.IntegerDatatypeInterface;
  validity_status: fromDatatype.VarcharDatatypeInterface;
  terms_and_condition: fromDatatype.TextDatatypeInterface;
  is_shipping_voucher: boolean;
}
